
    export default {
        name: 'TabBar',

        props: {
            titleClass: {
                type: String,
                default: 'text-title-2',
            },
        },

        data() {
            return {
                selectedIndex: 0,
                tabs: [],
            };
        },

        created() {
            this.tabs = this.$children;
        },

        mounted() {
            this.initActiveTab();
        },

        methods: {
            initActiveTab() {
                const findActiveTabIndex = this.tabs.findIndex(tab => tab.active);
                const activeTabIndex = findActiveTabIndex > -1 ? findActiveTabIndex : 0;
                this.selectTab(activeTabIndex, this.tabs[0], false);
            },

            selectTab(i, selectedTab, emit = true) {
                const prevIndex = this.selectedIndex;
                this.selectedIndex = i;
                this.tabs[prevIndex].isActive = false;
                this.tabs[i].isActive = true;

                if (emit) {
                    this.$emit('selectedTab', i, selectedTab);
                }
            },
        },
    };
